import { render, staticRenderFns } from "./BaseUsersListSection.vue?vue&type=template&id=4c66d376&scoped=true&"
import script from "./BaseUsersListSection.vue?vue&type=script&lang=js&"
export * from "./BaseUsersListSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseUsersListSection.vue?vue&type=style&index=0&id=4c66d376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66d376",
  null
  
)

export default component.exports